/* eslint-disable complexity */
// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { useIntl } from "react-intl";

import { N900 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";

import { PatternLogos } from "@/patterns/wpl/logos/src";

const inlineLogosProp = [
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/svgs/canva-n50.svg",
        alt: "Canva",
        width: "83px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:35c6a74c-a259-4dac-8df8-ea8c5b12f44d/nasa-n50.svg",
        alt: "Nasa",
        width: "52px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:5a1e47e3-be98-4279-a3a2-c626164dbd5d/illumina-n50.svg",
        alt: "Illumina",
        width: "90px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:731482d9-54c4-48e7-a10b-ab601ca4fbd6/docker-n50.svg",
        alt: "Docker",
        width: "95px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:475f41d8-45f4-48c9-a9b2-d78215ae4b16/nyt-n50.svg",
        alt: "The New York Times",
        width: "145px"
    },
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/svgs/audi-n50.svg",
        alt: "Audi",
        width: "60px"
    }
];

const patternLogosConfluencePageStyle = css`
    @media (max-width: 29.99rem) {
        padding: ${token("space.400")} ${token("space.200")}
            ${token("space.600")};
    }

    @media (min-width: 30rem) and (max-width: 47.99rem) {
        padding: ${token("space.500")} ${token("space.600")}
            ${token("space.600")};
    }

    @media (min-width: 48rem) {
        padding: 0 0 ${token("space.600")};
    }

    .text-section {
        h2 {
            font-weight: 400;
            text-align: center;
            color: ${N900};
            margin-top: 0;
            font-family: var(--bxp-charlie-text-font-family);

            @media (max-width: 63.99rem) {
                font-size: 1.125rem;
                line-height: 1.625rem;
            }

            @media (min-width: 64rem) {
                font-size: 1.25rem;
                line-height: 1.75rem;
            }
        }
    }

    .row-layout {
        width: 100%;
        padding: 0;

        .logos-content {
            display: flex;
            flex-wrap: wrap;
            gap: 48px;
            align-items: center;
            justify-content: center;
            max-width: 1000px;
            margin: auto;

            @media (max-width: 450px) {
                max-width: 320px;
            }

            @media (min-width: 720px) and (max-width: 924.99px) {
                max-width: 656px;
            }

            .logoblock {
                margin: auto 0;
                + img {
                    vertical-align: bottom;
                    point-events: none;
                    max-width: 100%;
                }
            }
        }
    }

    .row-layout:last-child {
        margin-top: ${token("space.0")};
    }
`;

const SocialProof = () => {
    const intl = useIntl();
    const patternLogoBodyText = intl.formatMessage({
        id: "ConfluenceSoftwarePageTemplate.socialProofShort.bodyText",
        defaultMessage:
            "75,000+ customers rely on Confluence to share knowledge"
    });

    return (
        <div>
            <PatternLogos
                css={patternLogosConfluencePageStyle}
                inlineLogos={inlineLogosProp}
                headerText={patternLogoBodyText}
            />
        </div>
    );
};

export default SocialProof;
